import React from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import ViewRTO from './ViewRTO'
import EmailMessage from '../../shared/email-message/EmailMessage'

function RTOModal({ onClose, UserAction, show, selectedRow, moduleName }) {
    let modalAction
    let showButtons
    const userAction = reactStringReplace(UserAction, 'User', () => '')

    if (UserAction === 'View') {
        modalAction = <ViewRTO rtoData={selectedRow} />
        showButtons = (
            <div>
                <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Close</button>
            </div>
        )
    } else if (UserAction === 'Email') {
        modalAction = (
            <EmailMessage
                FinanceRegisterData={selectedRow}
                onCancel={onClose}
                onSent={onClose}
                moduleName={moduleName}
            />
        )
        showButtons = null
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
            dialogClassName="modal-dialog-centered stock-adjust-modal"
        >
            <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
                <ModalTitle>{userAction} {moduleName}</ModalTitle>
            </ModalHeader>
            <ModalBody>{modalAction}</ModalBody>
            <ModalFooter>{showButtons}</ModalFooter>
        </Modal>
    )
}

export default RTOModal